// Chakra imports
import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Card,
	Flex,
	Heading,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { fadeUp } from 'utils/animation';
import { FAQ_ITEMS } from 'views/client/faqs/variable/faqs';

const animation = `${fadeUp} 0.6s ease-out forwards`;

export default function BumbeiFAQ() {
	const cardBg = useColorModeValue('gray.100', 'gray.500');
	const iconBg = useColorModeValue('black', 'white');
	const location = useLocation();
	const isClient = location.pathname.includes('client');

	return (
		<Box
			maxW={isClient ? '100%' : '900px'}
			alignSelf={isClient ? 'stretch' : 'center'}
			pt={isClient ? { base: '80px', md: '80px', xl: '80px' } : '0'}
			width='100%'
		>
			<Heading mb='20px' fontSize='2xl' ms='24px' fontWeight='700'>
				¿Cómo funciona Bumbei?
			</Heading>
			<Card mb='20px' bg={cardBg} p={6} animation={animation} opacity={0}>
				<Accordion allowToggle>
					{FAQ_ITEMS.map(({ icon: Icon, question, answer }, index) => (
						<AccordionItem key={index} border='none'>
							{(props) => {
								const { isExpanded } = props;
								return (
									<>
										<h2>
											<AccordionButton
												_expanded={{ bg: 'brand.500', color: 'gray.100' }}
												borderRadius='16px'
											>
												<Flex
													align='center'
													gap={3}
													flex='1'
													textAlign='left'
													py={4}
												>
													<Icon
														fontSize='medium'
														style={{
															color: isExpanded ? '#F7FAFC' : iconBg,
															transition: 'color 0.2s ease',
														}}
													/>
													<Text fontSize='lg' fontWeight='medium'>
														{question}
													</Text>
												</Flex>
												<AccordionIcon />
											</AccordionButton>
										</h2>
										<AccordionPanel py={8}>{answer}</AccordionPanel>
									</>
								);
							}}
						</AccordionItem>
					))}
				</Accordion>
			</Card>
		</Box>
	);
}
